/*
 * Merchant-related constants
 * LootShop merchant ID (used for the rewards shop)
 */
export const DEVOUR_MERCHANT_ID = "674a30b9b53b4c9f4aee6587";